import styled from 'styled-components';
import { useTranslation } from '@hooks';

import { MenuItem } from 'components/account/AccountMenu';
import { Caption2 } from '@components/styles/Typography';

const StaticMenuItems = ({ slug, name }) => {
    const { locale } = useTranslation();
    return (
        <div>
            <StaticMenuLink href={slug[locale]}>
                <MenuItem paddingZero>
                    <Caption2>{name[locale]}</Caption2>
                </MenuItem>
            </StaticMenuLink>
        </div>
    );
};

const StaticMenuLink = styled.a`
    cursor: pointer;
`;
export default StaticMenuItems;
